/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileCard_delegate = {
    readonly uuid: string;
    readonly firstName: string;
    readonly profileImageUrl: string | null;
    readonly lastName: string;
    readonly email: string | null;
    readonly TTC_ID: string;
    readonly telephone: string | null;
    readonly jobTitle: string;
    readonly backgroundCheckPending: boolean;
    readonly hasActiveBackgroundCheck: boolean;
    readonly pendingBackgroundCheck: {
        readonly approvalDate: string | null;
        readonly applicationSentAt: string | null;
        readonly applicationReceivedAt: string | null;
        readonly hasAllResponses: boolean;
        readonly requestedDBS: boolean;
        readonly isRenewal: boolean;
        readonly isVerification: boolean;
    } | null;
    readonly currentBackgroundCheck: {
        readonly approvalDate: string | null;
        readonly expiresAt: string | null;
        readonly idExpiryDate: string | null;
        readonly dbsExpiryDate: string | null;
        readonly isVerification: boolean;
    } | null;
    readonly " $refType": "ProfileCard_delegate";
};
export type ProfileCard_delegate$data = ProfileCard_delegate;
export type ProfileCard_delegate$key = {
    readonly " $data"?: ProfileCard_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileCard_delegate">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "approvalDate",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isVerification",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ProfileCard_delegate",
        "type": "Delegate",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "uuid",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "profileImageUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "TTC_ID",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "telephone",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "jobTitle",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "backgroundCheckPending",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasActiveBackgroundCheck",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pendingBackgroundCheck",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "applicationSentAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "applicationReceivedAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasAllResponses",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "requestedDBS",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isRenewal",
                        "args": null,
                        "storageKey": null
                    },
                    (v1 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "currentBackgroundCheck",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "expiresAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "idExpiryDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dbsExpiryDate",
                        "args": null,
                        "storageKey": null
                    },
                    (v1 /*: any*/)
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'e7158ca22152106ae4e731dc9d475aad';
export default node;
